import {hamburger} from "./components/c-hamburger"
import {searchModal} from "./components/c-searchModal"
import { swiper } from "./components/c-swiper"
import Dropdown from "./components/c-dropdown"
import {accordion} from "./components/c-accordion"
import {toggleActiveGallery} from "./components/c-toggleActive-gallery";

// const menus = document.querySelectorAll('.js_dropDown');//data-menuがついてる要素すべてを取得し、classへわたす
// menus.forEach(menu => new Dropdown2(menu));//ドロップダウン1個ずつにclass構文を適用

swiper()
hamburger()
searchModal()
accordion()

const elem = Array.from(document.querySelectorAll('.js_dropDown'));
const dropdown = new Dropdown(elem);

toggleActiveGallery()
